/**
 * This place where we put out
 * Chat definitions method
 */

export const actions = {
  connect: 'connect',
  disconnect: 'disconnect',
  enterChannel: 'enterChannel',
  leaveChannel: 'leaveChannel',
  leavePreviousChannels: 'leavePreviousChannels',
  updateCustomType: 'updateCustomType',
  loadInitialMessages: 'loadInitialMessages',
  loadOlderMessages: 'loadOlderMessages',
  sendTextMessage: 'sendTextMessage',
  sendImage: 'sendImage',
  deleteMessage: 'deleteMessage',
  registerChatListener: 'registerChatListener',
  unregisterChatListener: 'unregisterChatListener',
  initializeCurrentChannel: 'initializeCurrentChannel',
  updateUserInfo: 'updateUserInfo',
  startTyping: 'startTyping',
  endTyping: 'endTyping'
};

export const mutations = {
  setMessages: 'setMessages',
  insertNewMessage: 'insertNewMessage',
  insertOlderMessages: 'insertOlderMessages',
  resolveNewMessage: 'resolveNewMessage'
};

export default {
  actions,
  mutations
};
